import { render } from "./SmartFilterDataProviderAndGame.vue?vue&type=template&id=342c03ea"
import script from "./SmartFilterDataProviderAndGame.vue?vue&type=script&lang=js"
export * from "./SmartFilterDataProviderAndGame.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__